import React, { useState } from "react";
import LineBox from "../../../DefaultStyles/LineBox";
import Table, { TableBody, TableBodyItem } from "../../../Table/Table";
import dayjs from "dayjs";
import LineBtn from "../../../Button/LineBtn";
import UpdateCertiModal from "./ManageCerti/UpdateCertiModal";

interface ManageCertiProps {
  certiData?: {
    admin?: string;
    certi: 1 | 2;
    lastupdate?: string;
  };
  refetch: () => void;
}

const certiFromEnum = {
  1: "아임포트",
  2: "나이스",
};

export default function ManageCerti({ certiData, refetch }: ManageCertiProps) {
  const [updateModal, setUpdateModal] = useState(false);

  const tableHead = ["본인 인증사", "최근 업데이트 일시", "담당자", "업데이트"];

  return (
    <>
      <LineBox>
        <Table tableHeadData={tableHead}>
          <TableBody>
            <TableBodyItem>
              {certiFromEnum[certiData?.certi ?? 1]}({certiData?.certi})
            </TableBodyItem>
            <TableBodyItem>
              {certiData?.lastupdate
                ? dayjs(certiData?.lastupdate).format("YYYY-MM-DD HH:mm:ss")
                : "-"}
            </TableBodyItem>
            <TableBodyItem>{certiData?.admin ?? "-"}</TableBodyItem>
            <TableBodyItem>
              <LineBtn
                btnText="업데이트"
                btnClickEvent={() => setUpdateModal(true)}
              />
            </TableBodyItem>
          </TableBody>
        </Table>
      </LineBox>

      {updateModal && (
        <UpdateCertiModal
          closeEvent={() => setUpdateModal(false)}
          confirmEvent={() => {
            refetch();
          }}
        />
      )}
    </>
  );
}
